<ng-container [formGroup]="newEditForm">
    <td class="icon">
        <i *ngIf="paisDenominacion && (paisDenominacion.lsMarcasAsociadas && paisDenominacion.lsMarcasAsociadas.length > 0)" class="fa-regular fa-circle-check"
            title="{{'titles.marcasAsociadas' | translate}}"></i>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="paises" [selectedItem]="newEditForm.get('pais')" [disabled]="disabled" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasCaja" [selectedItem]="newEditForm.get('grupoEtiquetasCaja')"
            [disabled]="disabledCaja" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <app-filterable-list [itemsList]="allGrupoEtiquetasPallet"
            [selectedItem]="newEditForm.get('grupoEtiquetasPallet')" [disabled]="disabledPallet" [placeHolder]="false">
        </app-filterable-list>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'permiso' + randomId}}" formControlName="forzarImprimirDestino">
        <label for="{{'permiso' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'gestionIncidencias' + randomId}}" formControlName="gestionIncidencias">
        <label for="{{'gestionIncidencias' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'lectura' + randomId}}" formControlName="permisoLecturaDataMatrixPublica">
        <label for="{{'lectura' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'confeccion' + randomId}}" formControlName="permisoConfeccionPallet">
        <label for="{{'confeccion' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short" [ngClass]="{'show-error': showError}">
        <input type="checkbox" id="{{'etiquetaCaja' + randomId}}" formControlName="etiquetaCajaConfeccionPalletRequerida">
        <label for="{{'etiquetaCaja' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short">
        <input [ngClass]="{ 'custom-error': showError && mensajes && !this.newEditForm.get('modoCertificado')?.value && !this.newEditForm.get('modoEtiquetas')?.value }" type="checkbox" id="{{'modoEtiquetas' + randomId}}" formControlName="modoEtiquetas">
        <label for="{{'modoEtiquetas' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="short">
        <input [ngClass]="{ 'custom-error': showError && mensajes && !this.newEditForm.get('modoCertificado')?.value && !this.newEditForm.get('modoEtiquetas')?.value }" type="checkbox" id="{{'modoCertificado' + randomId}}" formControlName="modoCertificado">
        <label for="{{'modoCertificado' + randomId}}" style="margin-bottom: unset;"></label>
    </td>
    <td class="multi-actions-subtable">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="fa-solid fa-trademark" app-click-stop-propagation (click)="openMarcas(paisDenominacion)" title="{{'titles.marcasAsociadas' | translate}}"></i>
            <i class="fas fa-pencil-alt" title="{{'titles.editar' | translate}}" app-click-stop-propagation (click)="edit(paisDenominacion)"></i>
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" app-click-stop-propagation (click)="askDelete(paisDenominacion)"
            [ngClass]="{'disabled': paisDenominacion && paisDenominacion.lsMarcasAsociadas && paisDenominacion.lsMarcasAsociadas.length !== 0}"></i>
        </ng-container>
    </td>
</ng-container>
<app-toast *ngIf="showError && mensajes" [messages]="mensajes" (closed)="showError=$event"></app-toast>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="closeModal()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="marcasModal">
    <div class="modal-content" id="modal-table">
        <header>
            <h4>{{'mantenimientoDenominaciones.paisDenominacion.marcas.titulo' | translate }}</h4>
        </header>
        <app-marcas-pais-denominacion class="component" [paisId]="paisId" [denominacionId]="denominacionId"
            (refresh)="toRefresh($event)"></app-marcas-pais-denominacion>
    </div>
</div>
